import { API_ROUTES } from "@/constants/apiRoutes";
import { httpRequestServer } from "@/services/httpRequestServer";

export const authDataService = {
  getInternalTokenAsync: async (nonce: string) : Promise<string> => {
    return await httpRequestServer.get(`${API_ROUTES.AUTHENTICATION}/internal-token?nonce=${nonce}`);
  }
};